<template>
  <div>
    <div v-if="initialLoading"><i class="ti-bell"></i> loading...</div>
    <div v-else>
      <drop-down
        class="nav-item"
        :title="total + ' Notifications'"
        @change="dropDownChanged($event)"
        title-classes="nav-link"
        icon="ti-bell"
        @scroll:end="loadMore"
      >
        <div class="relative">
          <div v-for="notification in notifications">
            <div @click="markAsRead(notification)" class="dropdown-item">
              <div class="dropdown-item__title">
                <span class="dropdown-item__title__text"> {{ notification.data.message }} </span>
              </div>
              <span class="dropdown-item__timestamp"> {{ notification.created_at_for_human }} </span>
            </div>
          </div>
        </div>
      </drop-down>
    </div>
  </div>
</template>

<script>
import NotificationController from '@/controllers/Notification/NotificationController';
import MoonLoader from '@/components/svg/SvgLoaderMoon';

export default {
  name: 'NotificationDropDown',
  components: { MoonLoader },
  data() {
    return {
      initialLoading: true,
      notifications: [],
      loading: false,
      total: null,
      lastPage: null,
      page: 1,
    };
  },
  async mounted() {
    this.initialLoading = true;
    this.getNotifications();
    this.initialLoading = false;
  },
  methods: {
    async loadMore() {
      this.page++;
      this.getNotifications();
    },
    async getNotifications() {
      this.loading = true;
      const {
        data: notifications,
        meta: { total, last_page },
      } = await NotificationController.paginate({
        per_page: 10,
        page: this.page,
      });

      this.total = total;
      this.lastPage = last_page;
      this.notifications = this.notifications.concat(notifications);
      this.loading = false;

      return this.notifications;
    },
    async markAsRead(notification) {
      this.$gtag.event('Notification Marked as Read', { method: 'Google' });
      await NotificationController.markAsRead({ id: notification.id });
      await this.getNotifications();
    },
    dropDownChanged(isOpened) {
      if (isOpened) this.$gtag.event('Notification Dropdown Opened', { method: 'Google' });
    },
  },
};
</script>

<style scoped>
.customLink {
  text-decoration: none;
}

/*.router-link-exact-active active*/
</style>
